<!-- ═══════════════════════════════════════════
     V3 DESIGN — Resume Requests Received
     ═══════════════════════════════════════════ -->
<ng-container *ngIf="designVersion === 'v3'">
  <!-- Infinite scroll delegated to the outer `.jc-v3-entity-details-body`
       container. Do NOT add `.sub-entities-scroll-container` here — that
       V2-only class globally sets `overflow-y: scroll` (_common.scss:2305)
       and makes this div its own scroll viewport, stealing wheel events
       from the outer container so `(scrolled)` never fires. -->
  <div infiniteScroll
    [infiniteScrollDistance]="5"
    [infiniteScrollThrottle]="200"
    [alwaysCallback]="true"
    [infiniteScrollContainer]="'.jc-v3-entity-details-body'"
    [fromRoot]="true"
    (scrolled)="onScrollDown()">
    <app-common-skeleton *ngIf="loadAPIcall && viewedList?.length === 0" [countforView]="5"
      [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
    <ng-container *ngIf="viewedList?.length > 0">
      <!-- `featured-background` = the app-wide upgraded/featured tint
           (#fffcf0, _common.scss:3253). Driven by the JOB here, since each
           row is a job — same binding shape as the job-side Resume Requests
           row (candidate-card-table-view.component.html:339) and the other
           candidate-side job rows (job-card.component.html:2285). -->
      <!-- Blocked/unavailable candidates disable the whole row — parity with the
           Job Invites / Applied rows, whose shared card factors the candidate
           into the same class (job-card.component.html:2284). The greying +
           click suppression come from the global `.disabled` (styles.scss:3210). -->
      <div class="jc-v3-cand-card" *ngFor="let items of viewedList; let i = index"
        [ngClass]="{'disabled': (items?.jobDetails && items?.jobDetails?.status !== 'ACTIVE')
                                || (candidateDetails && (candidateDetails?.status !== 'ACTIVE' || !candidateDetails?.availability)),
                    'featured-background': items?.jobDetails?.isFeatured === true}">
        <div class="jc-v3-cand-top">

          <!-- Rank -->
          <div class="jc-v3-c-rank">{{ i + 1 }}</div>

          <!-- Col1: Recruiter who sent the request -->
          <div class="jc-v3-c-col1">
            <div class="jc-v3-c-rec-row">
              <!-- Photo when the API returns one (TS at line 615-618 already
                   builds the absolute URL with AppSettings.photoUrl); falls
                   back to hashed-pastel initials when missing. Mirrors the
                   pattern in candidates-page.component.html:503-510. -->
              <img *ngIf="items?.photo" class="jc-v3-c-rec-av"
                [src]="items?.photo" alt="Owner avatar"
                (error)="$any($event.target).style.display='none'">
              <div *ngIf="!items?.photo" class="jc-v3-c-rec-av"
                [style.background-color]="getColortwo(items?.user?.firstName, items?.user?.lastName)"
                [style.color]="getTextColor(items?.user?.firstName, items?.user?.lastName)">
                {{ getInitialstwo(items?.user?.firstName, items?.user?.lastName) }}
              </div>
              <!-- Same rec-info wrapper as the job-side Resume Requests col1
                   (candidate-card-table-view.component.html:358) — flex:1 +
                   min-width:0 is what lets the name/role ellipsis kick in
                   instead of clipping mid-word. -->
              <div class="jc-v3-c-rec-info" style="flex:1;min-width:0;overflow:hidden;">
                <div class="jc-v3-c-rec-name"
                     [title]="items?.user?.firstName + ' ' + items?.user?.lastName">
                  {{ items?.user?.firstName }} {{ items?.user?.lastName }}
                </div>
                <!-- Name + title only — parity with the job-side Resume
                     Requests col1, which shows the formatted user type
                     without the organisation. -->
                <div class="jc-v3-c-rec-role" *ngIf="userTypeMap[items?.user?.userType]"
                     [title]="userTypeMap[items?.user?.userType]">
                  {{ userTypeMap[items?.user?.userType] }}
                </div>
              </div>
            </div>
          </div>

          <!-- Col2: Job info -->
          <div class="jc-v3-c-col2">
            <div class="jc-v3-c-name-row" [ngClass]="{'click-blocked': isRoutingDisabled}"
              (click)="openJobSlider(items?.jobDetails)" style="cursor:pointer;" id="candidate_requests_job_title_link_v3">
              <span class="jc-v3-c-name jc-v3-c-name-link" [title]="items?.jobDetails?.jobTitle || '—'">{{ items?.jobDetails?.jobTitle || '—' }}</span>
              <span class="jc-v3-c-cid" *ngIf="items?.jobDetails?.jobReferenceId" [title]="items?.jobDetails?.jobReferenceId">{{ items?.jobDetails?.jobReferenceId }}</span>
              <!-- AUDIT_04 Batch 4 — "On Hold" pill when ACTIVE-but-unavailable
                   (parity with V2; previous V3 always rendered "Active"). -->
              <span class="jc-v3-c-pill jc-v3-c-pill-g" *ngIf="items?.jobDetails?.status === 'ACTIVE' && items?.jobDetails?.availability !== false">Active</span>
              <span class="jc-v3-c-pill jc-v3-c-pill-am" *ngIf="items?.jobDetails?.status === 'ACTIVE' && items?.jobDetails?.availability === false">On Hold</span>
              <!-- BLOCKED pill - uses job-card styling for visual consistency (no border, correct colors) -->
              <span class="jc-v3-c-cand-status"
                    *ngIf="items?.jobDetails?.status === 'BLOCKED'"
                    [style.background-color]="'#ffe5e5'"
                    [style.color]="'#d40000'">Blocked</span>
              <!-- Non-ACTIVE job statuses (Filled / On Hold / Blocked / …) take
                   their color from the inherited FormValidation.getStyle() —
                   same palette the Job Invites / Applied pills use
                   (job-card jc-v3-row, APPLICANT_STATUS_COLOR). Unknown
                   statuses fall back to the class's gray. -->
              <span class="jc-v3-c-pill jc-v3-c-pill-gr" *ngIf="items?.jobDetails?.status && items?.jobDetails?.status !== 'ACTIVE' && items?.jobDetails?.status !== 'BLOCKED'"
                    [style.background]="getStyle(items?.jobDetails?.status)?.background || null"
                    [style.color]="getStyle(items?.jobDetails?.status)?.color || null"
                    [style.border-color]="getStyle(items?.jobDetails?.status)?.background || null">
                {{ items?.jobDetails?.status | titlecase }}
              </span>
            </div>
            <div class="jc-v3-c-exp" *ngIf="items?.jobDetails?.experienceFrom || items?.jobDetails?.experienceTo">
              {{ items?.jobDetails?.experienceFrom }}–{{ items?.jobDetails?.experienceTo }} yrs exp
            </div>
            <div class="jc-v3-c-meta">
              <div class="jc-v3-c-mi" *ngIf="items?.jobDetails?.city || items?.jobDetails?.state">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                {{ items?.jobDetails?.city }}<ng-container *ngIf="items?.jobDetails?.state">, {{ items?.jobDetails?.state }}</ng-container>
              </div>
              <!-- AUDIT_04 Batch 4 — client name + client type tags.
                   Parity with V2 `:91-122`; V3 previously dropped them. -->
              <div class="jc-v3-c-mi" *ngIf="items?.jobDetails?.showClientName && items?.jobDetails?.clientName" [title]="items?.jobDetails?.clientName">
                <ng-icon name="tablerBuilding"></ng-icon>
                {{ items?.jobDetails?.clientName }}
              </div>
              <div class="jc-v3-c-mi" *ngIf="items?.jobDetails?.showClientType && items?.jobDetails?.clientType">
                <ng-icon name="tablerBriefcase"></ng-icon>
                {{ items?.jobDetails?.clientType }}
              </div>
            </div>
            <div class="jc-v3-c-foot">
              <span class="jc-v3-c-pill jc-v3-c-pill-p" *ngIf="items?.jobDetails?.workMode">{{ items?.jobDetails?.workMode }}</span>
              <span *ngIf="items?.jobDetails?.jobClassification" style="font-size:10px;color:#6B7280;">{{ items?.jobDetails?.jobClassification }}</span>
              <!-- AUDIT_04 Batch 4 — employer estimate (rate) with currency
                   + pay-type suffix (parity with V2 `:123-153`). -->
              <span class="jc-v3-c-rate" *ngIf="items?.jobDetails?.targetRateFrom && items?.jobDetails?.targetRateTo; else noRateResumeReq"
                    [title]="'Employer estimate: ' + (items?.jobDetails?.country === 'US' ? '$' : '') + items?.jobDetails?.targetRateFrom + ' - ' + items?.jobDetails?.targetRateTo">
                <span *ngIf="items?.jobDetails?.country === 'US'">$</span>{{ items?.jobDetails?.targetRateFrom }}–{{ items?.jobDetails?.targetRateTo }}
                <span *ngIf="items?.jobDetails?.country === 'US'"> USD / </span>
                <span *ngIf="items?.jobDetails?.country === 'IN'"> INR / </span>
                <span *ngIf="items?.jobDetails?.country === 'CA'"> CAD / </span>
                <span *ngIf="items?.jobDetails?.country === 'AU'"> AUD / </span>
                <span *ngIf="items?.jobDetails?.country && items?.jobDetails?.country !== 'US' && items?.jobDetails?.country !== 'IN' && items?.jobDetails?.country !== 'CA' && items?.jobDetails?.country !== 'AU'"> CUR / </span>
                <span *ngIf="items?.jobDetails?.payType === 'Hourly'">Hr</span>
                <span *ngIf="items?.jobDetails?.payType === 'Daily'">Day</span>
                <span *ngIf="items?.jobDetails?.payType === 'Weekly'">Week</span>
                <span *ngIf="items?.jobDetails?.payType === 'Monthly'">Month</span>
                <span *ngIf="items?.jobDetails?.payType === 'Yearly'">Year</span>
              </span>
              <!-- No employer rate on the job — show an explicit "not available"
                   instead of a half-rendered "$– USD /" chip. -->
              <ng-template #noRateResumeReq>
                <span class="jc-v3-c-rate" title="Employer estimate: Not available">$ Not available</span>
              </ng-template>
            </div>
          </div>

          <!-- Col3: Skills — primary first, then secondary; collapsed to 5 until
               "+N more" is clicked. Primary + secondary share one chip style
               (parity with the job card's V3 Col3). -->
          <div class="jc-v3-c-col3">
            <div class="jc-v3-c-skills">
              <span class="jc-v3-skill-tag"
                    *ngFor="let skill of (items.showAllSkills ? getAllSkills(items?.jobDetails) : getAllSkills(items?.jobDetails).slice(0, 5))">{{ skill }}</span>
              <span class="jc-v3-skill-more"
                    *ngIf="getAllSkills(items?.jobDetails).length > 5"
                    (click)="toggleSkills(items); $event.stopPropagation()">
                <ng-container *ngIf="!items.showAllSkills">+{{ getAllSkills(items?.jobDetails).length - 5 }} more</ng-container>
                <ng-container *ngIf="items.showAllSkills">Show less</ng-container>
              </span>
            </div>
          </div>

          <!-- Col4: status pill pinned top-right (via the --bottom modifier's
               auto margin, same as the job-side Resume Requests tab), with
               Views + Applicants + Like + Attach Resume + Apply + Chat
               packed to the bottom. -->
          <div class="jc-v3-c-col4 jc-v3-c-col4--bottom">
            <span class="jc-v3-status-pill jc-v3-c-invite-pill"
                  [style.background-color]="resumeRequestPillStyle(items)?.background"
                  [style.color]="resumeRequestPillStyle(items)?.color"
                  [style.border-color]="resumeRequestPillStyle(items)?.background">
              {{ resumeRequestPillLabel(items) }}
            </span>

            <!-- Buttons on their own single line above the counts row —
                 same stacking as the job-side Resume Requests col4
                 (Invite to Apply above the engagement row). -->
            <div class="jc-v3-c-btn-row"
              [ngClass]="{disabled: candidateDetails?.status !== 'ACTIVE' || !candidateDetails?.availability}">
              <!-- Attach Resume / Attached -->
              <button class="jc-v3-btn jc-v3-btn-primary jc-v3-btn-sm" *ngIf="items?.fileId == null"
                (click)="model(items, template)">
                <ng-icon name="tablerPaperclip" style="margin-right:4px;"></ng-icon> Attach Resume
              </button>
              <button class="jc-v3-btn jc-v3-btn-sm" *ngIf="items?.fileId != null"
                style="background: #e0f5f1; color: #2d7a6c;"
                (click)="model(items, template)" disabled>
                <ng-icon name="tablerPaperclip" style="margin-right:4px;"></ng-icon> Attached
              </button>

              <!-- Apply -->
              <button class="jc-v3-btn jc-v3-btn-primary jc-v3-btn-sm"
                *ngIf="items?.jobDetails?.jobPostedBy != userId && (userType == 'BENCH_RECRUITER' || userType == 'student' || userType == 'JOB_SEEKER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')"
                [class.disabled]="items?.jobDetails?.status != 'ACTIVE'"
                (click)="apply(items, connectionTemplate, candidateSupplyTemplate)">
                Apply
              </button>
            </div>

            <div class="jc-v3-c-act-row"
              [ngClass]="{disabled: candidateDetails?.status !== 'ACTIVE' || !candidateDetails?.availability}">

              <!-- Views -->
              <div class="jc-v3-c-eng-item"
                title="{{items?.jobDetails?.viewedByCount || 0}} Views" style="cursor:context-menu;">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                {{ items?.jobDetails?.viewedByCount | compactCount }}
              </div>

              <div class="jc-v3-c-eng-dot"></div>

              <!-- Like -->
              <div [title]="items?.jobDetails?.likesCount + ' Likes'" class="jc-v3-c-eng-item" *ngIf="items?.jobDetails?.isLiked != null"
                style="cursor:pointer;" (click)="like(items?.jobDetails)"
                [ngClass]="{'disabled': items?.jobDetails?.status !== 'ACTIVE'}">
                <svg viewBox="0 0 24 24"
                  [attr.fill]="items?.jobDetails?.isLiked ? '#F43F5E' : 'none'"
                  [attr.stroke]="items?.jobDetails?.isLiked ? '#F43F5E' : 'currentColor'" stroke-width="2">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                </svg>
                {{ items?.jobDetails?.likesCount | compactCount }}
              </div>

              <!-- View Job (eye) — opens the job slider, same as clicking the
                   job title. Placed after Like to match the Applied page's
                   View Job icon order (job-card.component.html:2531). Plain
                   (no background box) — the chat button keeps the purple box. -->
              <div class="jc-v3-c-viewjob-btn" title="View Job"
                (click)="openJobSlider(items?.jobDetails)">
                <ng-icon name="tablerEye"></ng-icon>
              </div>

              <!-- Applicants count -->
              <div class="jc-v3-c-eng-item" *ngIf="items?.jobDetails?.jobPostedBy != userId"
                title="{{items?.jobDetails?.appliedCount || 0}} Applicants" style="cursor:context-menu;">
                <ng-icon name="tablerUsers"></ng-icon>
                {{ items?.jobDetails?.appliedCount | compactCount }}
              </div>

              <!-- Chat / Messages.
                   AUDIT_04 Batch 4 — owner-side no-messages variant so the
                   candidate can initiate a chat with the requester even
                   when no thread exists yet (V2 `:210-217`). -->
              <div class="jc-v3-c-eng-item" *ngIf="items?.jobDetails?.chatHistoryCount > 0"
                title="{{items?.jobDetails?.nonSeenMessageCount > 0 ? items?.jobDetails?.nonSeenMessageCount + ' Messages' : 'No Messages'}}"
                (click)="openMessagecheckInteraction(items.jobDetails, connectionTemplate)">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                <span class="jc-v3-c-ibtn-badge" *ngIf="items?.jobDetails?.nonSeenMessageCount > 0">{{ items?.jobDetails?.nonSeenMessageCount }}</span>
              </div>
              <div class="jc-v3-c-ibtn"
                *ngIf="items?.jobDetails?.jobPostedBy != userId && items?.jobDetails?.chatHistoryCount == 0"
                title="No Messages" (click)="openMessagecheckInteraction(items.jobDetails, connectionTemplate)">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
              </div>
              <div class="jc-v3-c-ibtn"
                *ngIf="items?.jobDetails?.jobPostedBy == userId && items?.jobDetails?.chatHistoryCount == 0"
                title="No Messages" (click)="openMessagecheckInteraction(items.jobDetails, connectionTemplate)">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
              </div>
            </div>
          </div>

        </div>
      </div>
      <app-common-skeleton *ngIf="loadAPIcall && viewedList?.length > 0" [countforView]="2"
        [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
      <div *ngIf="stopscrollFlag && viewedList?.length > 0" class="jc-v3-list-done">
        <ng-icon name="tablerCircleCheck"></ng-icon>
        <p>You've reached the bottom of the page</p>
      </div>
    </ng-container>
    <div *ngIf="!loadAPIcall && viewedList?.length === 0 && emptymessage" class="jc-v3-empty-state">
      <svg width="200" height="180" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="100" cy="90" r="80" fill="#F5F3FF"/>
        <rect x="60" y="52" width="80" height="64" rx="8" fill="#EDE9FE" stroke="#7C3AED" stroke-width="1.8"/>
        <line x1="74" y1="72" x2="126" y2="72" stroke="#DDD6FE" stroke-width="2" stroke-linecap="round"/>
        <line x1="74" y1="82" x2="118" y2="82" stroke="#DDD6FE" stroke-width="2" stroke-linecap="round"/>
        <line x1="74" y1="92" x2="110" y2="92" stroke="#DDD6FE" stroke-width="2" stroke-linecap="round"/>
        <circle cx="148" cy="128" r="16" fill="#7C3AED" opacity="0.10"/>
        <circle cx="148" cy="128" r="11" fill="#ffffff" stroke="#7C3AED" stroke-width="2"/>
        <line x1="144" y1="128" x2="152" y2="128" stroke="#7C3AED" stroke-width="2" stroke-linecap="round"/>
        <line x1="148" y1="124" x2="148" y2="132" stroke="#7C3AED" stroke-width="2" stroke-linecap="round"/>
        <circle cx="50" cy="52" r="3" fill="#A78BFA"/>
        <circle cx="155" cy="56" r="2" fill="#C4B5FD"/>
      </svg>
      <h3>No Requests Received Yet</h3>
      <p>Resume requests from recruiters will appear here.</p>
    </div>
    <div #scrollSentinel style="height:1px;"></div>
  </div>
</ng-container>

<!-- ═══════════════════════════════════════════
     V2 DESIGN (existing)
     ═══════════════════════════════════════════ -->
<ng-container *ngIf="designVersion !== 'v3'">
<div class="sub-entities-scroll-container" infiniteScroll [infiniteScrollDistance]="5" [infiniteScrollThrottle]="200"
  [scrollWindow]="false" [alwaysCallback]="true" (scrolled)="onScrollDown()">

  <div class="col-md-12 padding-left-0 padding-right-5" *ngIf="loadAPIcall && viewedList?.length==0">
    <app-common-skeleton [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
  </div>

  <div class="wert" *ngIf="emptymessage && !loadAPIcall">
    <div class="col-md-12 mg-bt-9">
      <ng-icon name="tablerZoomQuestion"></ng-icon>
      <!-- <img style=" max-height: 9rem;" src="assets/icon/nothing_found.png" alt=""> -->
    </div>
    <div class="col-md-12 fig">No requests received yet. </div>
  </div>

  <ng-container *ngIf="viewedList.length> 0">
    <div *ngFor="let items of viewedList; let lastItem = last;">
      <div class="hpanel">
        <div class="panel-body pad-0 border-radius-top-left-right-6"
          [ngClass]="{disabled : (items?.jobDetails && items?.jobDetails?.status != 'ACTIVE')
                                 || candidateDetails?.status != 'ACTIVE' || !candidateDetails?.availability }">
          <div class="md-top-section">
            <div class="md-user-img">
              <img *ngIf="items?.photo!= null && items?.photo != undefined" class="img-circle" src={{items.photo}}>
              <div *ngIf="items.photo == undefined || items.photo == null">
                <div class="circles"
                  [style.background-color]="getColortwo(items?.user?.firstName, items?.user?.lastName)">
                  <div class="circle-text" [style.color]="getTextColor(items?.user?.firstName, items?.user?.lastName)">
                    {{ getInitialstwo(items?.user?.firstName,
                    items?.user?.lastName) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="md-user-info">
              <div class="md-user-info-line-1">
                <div class="md-user-name" title="{{items?.user?.firstName}} {{items?.user?.lastName}}">
                  {{items?.user?.firstName}} {{" "}} {{items?.user?.lastName}}
                </div>
              </div>
              <div class="md-user-info-line-2">
                <div class="md-user-type">
                  <span *ngIf="userTypeMap[items?.user?.userType]" title="{{items?.user?.userType}}">
                    {{ userTypeMap[items?.user?.userType] }}
                  </span>
                  <span *ngIf="items?.user?.organisation" title="{{items?.user?.organisation}}">
                    &#64;{{ items.user.organisation }}
                  </span>
                </div>
              </div>
              <div class="md-user-info-line-3">
                <ng-icon name="tablerClock"></ng-icon>
                <div class="md-time-stamp">{{items?.activityDate | timezoneDate}}</div>
              </div>
            </div>
            <div [ngClass]="{disabled : candidateDetails?.status != 'ACTIVE'||!candidateDetails?.availability }"
              class="md-action-buttons flx-strt">
              <button id="candidate_requests_attach_resume_button" type="button" class="btn btn-primary" *ngIf="items?.fileId == null"
                (click)="model(items,template)">
                <ng-icon name="tablerPaperclip" class="arrowclassreq"></ng-icon> Attach Resume</button>
              <button id="candidate_requests_resume_attached_button" class="btn btn-primary" *ngIf="items?.fileId!=null" (click)="model(items,template)" disabled>
                <ng-icon name="tablerPaperclip" class="arrowclassreq"></ng-icon> Resume Attached </button>
              <!-- <button  class="more-opt-btn">
                <img src="assets/icon/icons8-more-96.png" alt="" srcset="">
              </button>
              <ng-icon name="tablerDotsVertical" class="svg-position"></ng-icon> -->

            </div>
          </div>
          <div class="row">
            <div *ngIf="items.jobDetails" class="md-bottom-section row">
              <div class="col-sm-2 md-btn-container"></div>
              <div class="col-sm-10 md-job-route-content" [ngClass]="{'click-blocked': isRoutingDisabled}"
                (click)="open(items?.jobDetails)" id="candidate_requests_job_title_link">
                <div class="title-status-container">
                  <ng-icon name="tablerBriefcase" class="svg-position"></ng-icon>
                  <div class="md-job-title" title="{{items?.jobDetails?.jobTitle}}">{{items?.jobDetails?.jobTitle}}
                  </div>

                  <div class="closed-tag label-tag" [ngStyle]="getStyle('INACTIVE')"
                    *ngIf="(items.jobDetails?.status != 'ACTIVE'||!items.jobDetails?.availability)">
                    {{ items.jobDetails?.status != 'ACTIVE' ? convertSmallCase(items.jobDetails?.status) : 'On Hold' }}
                  </div>
                </div>

                <span class="md-experience">
                  Experience : {{ items.jobDetails?.experienceFrom}} to {{items.jobDetails?.experienceTo }}
                  Years
                </span>
                <div class="row clientDetailList"
                  title=" {{items?.jobDetails?.clientType}}, {{items?.jobDetails?.city}}, {{items?.jobDetails?.state}} ">
                  <div class="mb-5" title="{{items?.jobDetails?.clientName}}" *ngIf="items?.jobDetails?.showClientName">
                    <ng-icon name="tablerBuilding"></ng-icon>
                    {{items?.jobDetails?.clientName | truncate:20}}
                  </div>
                  <div class="mb-5" *ngIf="items?.jobDetails?.showClientType">
                    <ng-icon name="tablerBriefcase" class="svg-position"></ng-icon>
                    {{items?.jobDetails?.clientType}}
                  </div>
                  <div class="mb-5">
                    <ng-icon name="tablerMapPin" *ngIf="items?.jobDetails?.city || items?.jobDetails?.state" class="svg-position"></ng-icon>
                    {{items?.jobDetails?.city}}
                    <span *ngIf="items?.jobDetails?.state">,</span> {{items.jobDetails?.state}}
                  </div>

                  <div class="mb-5">
                    <ng-icon name="tablerBriefcase" title="{{items?.jobDetails?.jobClassification}}" class="svg-position"></ng-icon>
                    {{items?.jobDetails?.jobClassification}}
                  </div>
                  <div *ngIf="items?.jobDetails?.workMode=='Onsite'" class="mb-5" title="Onsite">
                    <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                    Onsite
                  </div>
                  <div *ngIf="items?.jobDetails?.workMode=='Remote'" class="mb-5" title="Remote">
                    <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                    Remote
                  </div>
                  <div *ngIf="items?.jobDetails?.workMode=='Hybrid'" class="mb-5" title="Hybrid">
                    <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                    Hybrid
                  </div>
                  <div
                    title="Employer Estimate: {{items?.jobDetails?.targetRateFrom}} - {{items?.jobDetails?.targetRateTo}}"
                    *ngIf="items?.jobDetails?.targetRateFrom!=undefined && items?.jobDetails?.targetRateTo!=undefined"
                    class="mb-5">
                    Employer estimate:
                    <span>
                      {{items?.jobDetails?.country === 'US' ?
                      '$' :
                      ''}} {{items?.jobDetails?.targetRateFrom}} - {{items?.jobDetails?.targetRateTo}}</span>

                    <span title="{{items?.jobDetails.country}}" *ngIf="items?.jobDetails?.country == 'US'"> USD /
                    </span>
                    <span title="{{items?.jobDetails.country}}" *ngIf="items?.jobDetails?.country == 'IN'"> INR /
                    </span>
                    <span title="{{items?.jobDetails.country}}" *ngIf="items?.jobDetails?.country == 'CA'"> CAD /
                    </span>
                    <span title="{{items?.jobDetails.country}}" *ngIf="items?.jobDetails?.country == 'AU'"> AUD /
                    </span>
                    <span title="{{items?.jobDetails.country}}"
                      *ngIf="items?.jobDetails?.country != 'AU' && items?.jobDetails?.country != 'US' && items?.jobDetails?.country != 'CA' && items?.jobDetails?.country != 'IN'">
                      CUR / </span>
                    <span title="{{items?.jobDetails.payType}}" *ngIf="items?.jobDetails?.payType == 'Hourly'">Hr</span>
                    <span title="{{items?.jobDetails.payType}}" *ngIf="items?.jobDetails?.payType == 'Daily'">Day</span>
                    <span title="{{items?.jobDetails.payType}}"
                      *ngIf="items?.jobDetails?.payType == 'Weekly'">Week</span>
                    <span title="{{items?.jobDetails.payType}}"
                      *ngIf="items?.jobDetails?.payType == 'Monthly'">Month</span>
                    <span title="{{items?.jobDetails.payType}}"
                      *ngIf="items?.jobDetails?.payType == 'Yearly'">Year</span>
                  </div>

                </div>
              </div>
            </div>
            <div *ngIf="items?.jobDetails==null" class="consistent-height"></div>
            <div class="md-bottom-section row" *ngIf="items?.jobDetails==null">

            </div>
            <div [ngClass]="{disabled : candidateDetails?.status != 'ACTIVE'||!candidateDetails?.availability }"
              *ngIf="items.jobDetails" class="md-interaction-section">
              <div class="md-interaction-element"
                *ngIf="items?.jobDetails?.jobPostedBy!=userId && items?.jobDetails?.viewedByCount > 0"
                title="{{items.jobDetails.viewedByCount}} Views" style="cursor: context-menu;">
                <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
                <span class="blue-color">{{ items.jobDetails.viewedByCount | compactCount }}</span>
                Views
              </div>
              <div class="md-interaction-element"
                *ngIf="items?.jobDetails?.jobPostedBy!=userId && items?.jobDetails?.viewedByCount == 0" title="0 Views"
                style="cursor: context-menu;">
                <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
                <span class="blue-color">0</span>
                Views
              </div>
              <div>
                <div class="md-interaction-element" [ngClass]="{'disabled': items.jobDetails.status!='ACTIVE'}"
                  title="Like" *ngIf="items.jobDetails?.isLiked!=null && !items.jobDetails?.isLiked">
                  <ng-icon name="tablerHeart" class="pointer icon-prime-color" id="candidate_requests_job_like_button"  (click)="like(items?.jobDetails)"></ng-icon>
                </div>
                <div class="md-interaction-element" [ngClass]="{'disabled': items?.jobDetails.status!='ACTIVE'}"
                  title="Unlike" *ngIf="items.jobDetails?.isLiked!=null &&  items?.jobDetails?.isLiked">
                  <ng-icon name="tablerHeart" class="liked pointer bg-heart" id="candidate_requests_job_unlike_button"  (click)="like(items.jobDetails)"></ng-icon>
                </div>
              </div>
              <div class="md-interaction-element" title="{{items?.jobDetails?.likesCount}} Likes"
                *ngIf="items?.jobDetails?.jobPostedBy==userId">
                <span class="blue-color"
                  *ngIf="items?.jobDetails?.likesCount>0">{{ items?.jobDetails?.likesCount | compactCount }}</span>
                <span *ngIf="items?.jobDetails?.likesCount>0"> Like<span *ngIf="items?.jobDetails?.likesCount>1">s
                  </span> </span>
                <div class="md-interaction-element" title="0 Likes" class="no-views"
                  *ngIf="items?.jobDetails?.jobPostedBy==userId && items?.jobDetails?.likesCount == 0"
                  style="cursor: context-menu!important;"><span class="blue-color" title="0 Like"> 0 </span> Like
                </div>
              </div>
              <div class="md-interaction-element" title="{{items?.jobDetails?.likesCount}} Likes"
                *ngIf="items?.jobDetails?.jobPostedBy!=userId" style="cursor: context-menu!important;">
                <span class="blue-color"
                  *ngIf="items?.jobDetails?.likesCount>0">{{ items?.jobDetails?.likesCount | compactCount }}</span>
                <span *ngIf="items?.jobDetails?.likesCount>0"> Like<span *ngIf="items?.jobDetails?.likesCount>1">s
                  </span>
                </span>
                <div class="md-interaction-element" title="0 Likes" class="no-views"
                  *ngIf="items?.jobDetails?.jobPostedBy!=userId && items?.jobDetails?.likesCount == 0"
                  style="cursor: context-menu!important;"><span class="blue-color" title="0 Likes"> 0 </span> Like
                </div>
              </div>
              <div class="md-interaction-element applicants-info"
                *ngIf="items?.jobDetails?.jobPostedBy != userId">
                <ng-icon name="tablerUsers"></ng-icon>
                <span class="applicants-count blue-color" title="{{items?.jobDetails?.appliedCount}} Applicants">
                  {{ items?.jobDetails?.appliedCount | compactCount }}
                </span>
                <span>Applicants</span>
              </div>

              <div class="md-interaction-element" (click)="apply(items, connectionTemplate, candidateSupplyTemplate)"
                [ngClass]="{'disabled': items?.jobDetails?.status!='ACTIVE'}" *ngIf=" items?.jobDetails?.jobPostedBy!=userId && (userType == 'BENCH_RECRUITER'
                      || userType == 'student' || userType == 'JOB_SEEKER'
                      || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')">
                <ng-icon name="tablerSend"></ng-icon>
                <div title="Apply">
                  Apply
                </div>
              </div>
              <div class="md-interaction-element pointer" *ngIf=" items?.jobDetails?.chatHistoryCount > 0"
                title="{{items?.jobDetails?.nonSeenMessageCount > 0 ? items?.jobDetails?.nonSeenMessageCount + ' Messages' : 'No Messages'}}"                  (click)="openMessagecheckInteraction(items.jobDetails, connectionTemplate)">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color chat-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                <span class="blue-color"
                  *ngIf="items?.jobDetails?.nonSeenMessageCount>0">{{items?.jobDetails?.nonSeenMessageCount}}</span>
                <span>Chat</span>
              </div>
              <div class="md-interaction-element pointer"
                *ngIf="items?.jobDetails?.jobPostedBy!=userId && items?.jobDetails?.chatHistoryCount == 0"
                (click)="openMessagecheckInteraction(items.jobDetails, connectionTemplate)" title="No Messages"
               >
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color chat-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                <span>
                  Chat
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>
      <app-common-skeleton *ngIf="loadAPIcall && viewedList?.length>0" [countforView]="6"
        [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
    </div>
  </ng-container>
</div>




<div class="gs-end-of-list" *ngIf="stopscrollFlag && viewedList?.length>0">
  <div class="wert">
    <div class="col-md-12 mg-bt-9">
      <ng-icon name="tablerCircleCheck"></ng-icon>
    </div>
    <div class="col-md-12">
      <p class="font-16">You've reached the bottom of the page</p>
    </div>
  </div>
</div>
</ng-container>

<ng-template #candidateSupplyTemplate>
  <ng-container>
    <div class="row mr-0">
      <div class="col-sm-8 pad-lt-rt-0">
        <div class="xs-heading-flex-parent">
          <div class="xs-heading-entity">My Candidates</div>
          <div class="xs-heading-payrate">Pay Rate</div>
          <div class="xs-heading-paytype">Type</div>
        </div>
        <div class="xs-body-container" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300"
          [scrollWindow]="false">
          <div>
            <app-candidates-page *ngIf="applyResponse?.length > 0" [viewSize]="'extra-small'"
              [candidatesFoundStatus]="candidateFoundStatus" [passValues]="applyResponse" [jobData]="jobDetails"
              [fromApply]="true" (selectedCandidate)="getchildData($event)"></app-candidates-page>
          </div>

        </div>
        <div class="xs-footer-container"></div>
      </div>
      <div class="col-sm-4 pad-lt-0 pad-rt-0">
        <div class="hpanel"  style="margin-bottom: 0px !important;border-radius: 20px 9px 9px 20px !important;">
          <div class="hpanel-heading xs-heading-flex-entity-detail">
            <div>Job Details</div>

            <button><span class="modalai-close" aria-hidden="true"
                (click)="closeCandidateSupplyModal()">&times;</span></button>
          </div>
          <div>
            <app-job-submit-skillfilter [resumes]="resumeData" [focus]="'job'" [jobData]="jobDetails"
              [termsChecked]="termsCheck" [formData]="rtrFormData" [dataPasstoSkillwidgets]="dataPasstoSkillwidgets"
              (emitRemoveTag)="removeUserfromTag($event)">
            </app-job-submit-skillfilter>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>



<ng-template #template>
  <div class="common-header-flex">
    <div> Resume Upload </div>
    <button>
      <span class="common-close" (click)="modalRef.hide()">×</span>
    </button>
  </div>

  <div class="panel-body">

    <div class="col-sm-12" style="margin-top: 17px;">
      <div class="dropdox-908" appDnd (fileDropped)="onFileDropped($event)" for="fileDropRef">
        <input #fileDropRef style="display: none" type="file" accept=".pdf,.doc,.docx,.txt" id="fileDropRef"
          (click)="fileDropRef.value=''"
          (change)="fileBrowseHandler($event.target.files)" />

        <div class="file-icon-908">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="12" y1="18" x2="12" y2="12"></line>
            <line x1="9" y1="15" x2="15" y2="15"></line>
          </svg>
        </div>
        <div>
          <label class="upload-title-908" for="fileDropRef">Upload Your Resume</label>
        </div>
        <div>
          <label class="upload-instruction-908" for="fileDropRef" id="aad">Drag your files here or click in this
            area.</label>
        </div>
        <div for="fileDropRef">
          <small class="upload-hint-908">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
        </div>
        <div *ngIf="fileDragdrop" class="file-preview-908 file-preview-entered-908">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
            <polyline points="13 2 13 9 20 9"></polyline>
          </svg>
          <span class="file-name-908" [title]="fileDragdrop?.fileName || fileDragdrop?.name">{{fileDragdrop?.fileName || fileDragdrop?.name}}</span>
          <ng-icon name="tablerX" class="file-remove-908" (click)="removeFiles()"></ng-icon>
        </div>
      </div>
    </div>

    <!-- <div class="col-sm-12" style="margin-top: 17px;"> 
      <div class="dropdox-908" appDnd (fileDropped)="onFileDropped($event)" for="fileDropRef">
        <input #fileDropRef style="display: none" type="file" accept=".pdf,.doc,.docx,.txt" id="fileDropRef"
          (change)="fileBrowseHandler($event.target.files)" />
        <i class="file-icon-908"></i>
        <div>
          <label class="upload-title-908" for="fileDropRef">Upload Your Resume</label>
        </div>
        <div>
          <label class="upload-instruction-908" for="fileDropRef" id="aad">Drag your files here or click in this area.</label>
        </div>
        <div>
          <small class="upload-hint-908">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
        </div>
      </div>
      <div *ngIf="fileDragdrop" class="file-preview-908 file-preview-entered-908">
        <span class="file-name-908">{{fileDragdrop?.name | truncate: 28}}</span>
        <ng-icon name="tablerX" class="svg-position file-remove-908"  (click)="removeFiles()"></ng-icon>
        <button class="file-remove-908" (click)="removeFiles()">×</button>
      </div>
    </div> -->

    <!-- <div class="files-list" *ngIf="fileDragdrop">
      <div class="single-files">
        <div class="info">
          <h4 class="name">
            {{ fileDragdrop?.name }}
          </h4>
          <p title="Download" class="cursor-pointer top-eye" (click)="onDownload()">
            <ng-icon name="tablerDownload" aria-hidden="true"></ng-icon>
          </p>
          <div (click)="removeFiles()" title="Remove File" class="tiimes">x</div>
        </div>
      </div>
    </div> -->

  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default" (click)="modalRef.hide()"> Cancel </button>
        <button class="btn  btn-primary" (click)="submit()">Save </button>
      </div>
    </div>
  </div>


</ng-template>

<ng-template #connectionTemplate>
  <app-connection-template [page]="'job-card'" [connectionStatus]="connectionStatus"
    [counterpartsDetails]="counterpartsDetails" [module]="'job'"></app-connection-template>
</ng-template>

<app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage($event)" [messageDataPass]="messageData">
</app-message-widget>